/* unplugin-vue-components disabled */import script from "./PointRepair.vue?vue&type=script&setup=true&lang=js"
export * from "./PointRepair.vue?vue&type=script&setup=true&lang=js"

import "./PointRepair.vue?vue&type=style&index=0&id=2e30abbd&scoped=true&lang=less"

import exportComponent from "D:\\项目\\blueSkyReportForm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e30abbd"]])

export default __exports__